<adaa-data-table
    titleHeader="national_projects.national_sector.title"
    [required]="true"
    [isLocalData]="true"
    [localData]="tableData"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.INTP_COUNTRIES_SECTORS_CONF_LIST"
    [enableAdd]="!isDisabled()"
    [enableEditAction]="!isDisabled()"
    [enableDeleteAction]="!isDisabled()"
    [enableExport]="false"
    [tableClasses]="invalid() ? 'table-striped table-hover table-danger' : 'table-striped table-hover'"
    (addNewClicked)="addNewClicked()"
    (actionClicked)="actionClicked($event)"
/>
